import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all meter readings
export const getMeterReadings = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/meter-readings`);
    return response.data;
  } catch (error) {
    console.error("Error fetching meter-readings:", error.response?.data || error);
    throw error;
  }
};

// GET a single meter reading
export const getMeterReadingsById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/meter-readings/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching meter-readings:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new meter reading
export const createMeterReadings = async (meterReadingsData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/meter-readings`, meterReadingsData);
    return response.data;
  } catch (error) {
    console.error("Error creating meter-readings:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing meter reading
export const updateMeterReadings = async (id, meterReadingsData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/meter-readings/${id}`, meterReadingsData);
    return response.data;
  } catch (error) {
    console.error("Error updating meter-readings:", error.response?.data || error);
    throw error;
  }
};

// DELETE a meter reading
export const deleteMeterReadings = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/meter-readings/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting meter-readings:", error.response?.data || error);
    throw error;
  }
};

// GET paginated meter readings
export const getPaginatedMeterReadings = async ({
  page = 1,
  pageSize = 100,
  search = '',
  assetId,
  metersId,
  sortField,
  sortOrder,
  includeInvalid,
}) => {
  const response = await axiosInstance.get(`${API_URL}/meter-readings-paginated`, {
    params: { page, pageSize, search, assetId, metersId, sortField, sortOrder, includeInvalid },
    paramsSerializer: (params) => {
      const query = new URLSearchParams();
      for (const key in params) {
        const value = params[key];
        if (Array.isArray(value)) {
          value.forEach((v) => query.append(key, v));
        } else if (value !== undefined && value !== null) {
          query.append(key, value);
        }
      }
      return query.toString();
    },
  });
  return response.data;
};

export const estimateMeterReading = async ({ assetId, taskId, meterId, providedDate }) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/meter-readings/estimate`, {
      params: { assetId, taskId, meterId, providedDate },
    });
    return response.data;
  } catch (error) {
    console.error('Error estimating meter reading:', error.response?.data || error);
    throw error;
  }
};

export const validateMeterReading = async (payload) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/meter-readings/validate`, payload);
    return response.data;
  } catch (error) {
    console.error('Error validating meter reading:', error.response?.data || error);
    throw error;
  }
};

export const uploadMeterReadingsReport = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axiosInstance.post(
      `${API_URL}/meter-readings/import-json`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error uploading meter readings report:', error.response?.data || error);
    throw error;
  }
};
